import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NavIconDashboard from './nav-icon-dashboard.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NavIconDashboard {...validProps} />;
}
SvgComponent.iconName = 'navIconDashboard';

/**
 * @deprecated This is a legacy icon
 */
export const NavIconDashboardIcon = svgIconWrapper(SvgComponent);
